/**
 * Assumes the container is justified with space between
 * @param {*} elementWidth
 * @param {*} gap
 * @param {*} containerWidth
 * @returns the maximum number of elements that will fit in the container
 */
export function maxElementsInWidth(elementWidth, gap, containerWidth) {
  if (elementWidth < 0 || gap < 0 || containerWidth < 0) {
    throw Error("A negative width is not allowed");
  }
  if (elementWidth == 0) {
    throw Error("The element width must be greater than 0");
  }
  if (elementWidth > containerWidth) {
    return 0;
  }
  // elementWidth(n) + gap(n-1) <= containerWidth
  // elementWidth(n) + gap(n) - gap(1) <= containerWidth
  // elementWidth(n) + gap(n) <= containerWidth + gap
  // n(elementWidth + gap) <= containerWidth + gap
  // n <= (containerWidth + gap) / (elementWidth + gap)
  return Math.floor((containerWidth + gap) / (elementWidth + gap));
}
